import { getStaticImageUrl } from '@utils/createImageUrl';

const AdDesc = ({ isMobile }: { isMobile?: boolean }) => {
  return (
    <div className="for-lawyer__ad-desc-content">
      {isMobile ? (
        <p className="for-lawyer-day-desc white view-on-visible">
          여러 분야 중 어떤 분야를 선택해야 좋을지 고민하다 담당 비즈니스 매니저에게 연락했다.
          <br />
          <br />
          <span className="for-lawyer-day-desc-bold">매니저님이 광고와 관련된 의견은 물론 광고</span>
          <br />
          <span className="for-lawyer-day-desc-bold">설정까지</span>진행해주셨다.
          <br />
          <br />
          게다가 지금은 <span className="for-lawyer-day-desc-bold">분야 광고 프로모션 기간</span>이라
          <br />
          광고 하나는 무료로 이용할 수 있다고 한다.
          <br />
          한결 든든한 마음이다. 효과가 있어야 할 텐데···
        </p>
      ) : (
        <p className="for-lawyer-day-desc white view-on-visible">
          여러 분야 중 어떤 분야를 선택해야 좋을지 고민하다 담당 비즈니스 매니저에게 연락했다. 매니저님이 광고와 관련된
          의견은 물론 광고 설정까지 진행해주셨다.
          <br />
          <br />
          한결 든든한 마음이다. 효과가 있어야 할 텐데···
        </p>
      )}

      <img
        className="for-lawyer-call-three-circle-image view-on-visible"
        src={getStaticImageUrl({ fileName: 'preview/call-motion-three-circle.gif' })}
      />

      <img
        className="for-lawyer-phone-ring-image view-on-visible"
        src={getStaticImageUrl({ fileName: 'preview/call-motion.gif' })}
      />
    </div>
  );
};

export default AdDesc;
